import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import Card from '../../../../../atoms/Cards/Card';
import { fontStyle } from '../../../../../theme/helpers/fontStyle';

export const $Title = styled.div`
  text-align: center;
  ${fontStyle('base')};
  font-weight: ${fontWeight('bold')};
  margin-bottom: ${spacing('xl')};
`;

export const $ActionRow = styled.div`
  display: flex;
  justify-content: center;
  gap: ${spacing('sm')};
`;

export const $AppointmentCalendarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
`;

export const $CalendarCard = styled(Card)`
  @media ${media.maxWidth.sm} {
    margin-left: calc(-1 * ${spacing('lg')});
    margin-right: calc(-1 * ${spacing('lg')});
    padding-left: 0;
    padding-right: 0;
  }
`;
